import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export const Loading = (props) => (
  <div {...props} className={"loading-shading-mui" + (props && props.className ? " " + props.className : "")}>
    <CircularProgress color={"primary"} className="loading-icon-mui" />
  </div>
);
